import React, { useContext } from "react";

import PanelHeader from "components/PanelHeader/PanelHeader.jsx";

import SettingsList from "views/Settings/List";
import PbxGroupList from "views/PbxGroups/List";
import { UserContext } from "context/UserContext";

const AdminSettingsList = () => {
  const { userHasAnyPermissions } = useContext(UserContext)

  return (
    <>
      <PanelHeader
        content={
          <div className="header text-center">
            <h2 className="title">Admin Settings</h2>
          </div>
        }
      />
      <div className="content">
        {userHasAnyPermissions(["all:settingsManagement", "read:settingsManagement", "admin"]) &&
          <SettingsList />
        }
        {userHasAnyPermissions(["all:pbxGroups", "read:pbxGroups", "admin"]) &&
          <PbxGroupList />
        }
      </div>

      

    </>
  );
};

export default AdminSettingsList;
